<app-overlay-panel [fullWidth]="onConfig" [isShowing]="location != null" class="locationDetail">
    <div class="overlay-header-item locationDetail-header" *ngIf="location">
        <div *ngIf="location" class="locationDetail-header-item">
            <button class="btn btn-secondary btn-lg btn-outline btn-white" (click)="closeConfiguration()">
                <i class="fa fa-arrow-right"></i>
            </button>
            <div class="locationDetail-header-title">
                <div>{{ location.name }}</div>
                <div class="locationDetail-header-tags">
                    <div class="locationDetail-header-tags-item"> {{ location.type }}</div>
                    <div class="locationDetail-header-tags-item"
                         [i18n]="'local-loads.locations.detail.information.' + (location.configuration?.colt ? 'is-colt' : 'is-not-colt')"></div>
                    <div class="locationDetail-header-tags-item"
                         [i18n]="'local-loads.locations.detail.information.' + (location.configuration?.ymsCompatible.compatible ? 'is-yms' : 'is-not-yms')"></div>
                </div>
            </div>
        </div>
        <div *ngIf="location" class="locationDetail-header-item">
            <button *ngIf="canManageLocations" class="btn btn-secondary btn-lg btn-i btn-outline btn-white"
                    (click)="syncWithSAP()">
                <i class="fa fa-sync-alt"></i>
                <span [i18n]="'local-loads.locations.detail.buttons.sync-this-location'"></span>
            </button>
        </div>
    </div>

    <app-tabs *ngIf="location" class="overlay-content">
        <app-tab *ngIf="!onConfig" [tabId]="'info'"
                 [selected]="activeTab === 'info'"
                 [tabTextKey]="'local-loads.locations.detail.tab.info'"
                 (selectedChange)="activeTab = 'info'">
            <ng-container *ngTemplateOutlet="locationInfo"></ng-container>
            <app-address-picker class="locationDetail-addressPicker"
                                [latitude]="location.latitude"
                                [longitude]="location.longitude"
                                [radius]="location.configuration.forcedCheckinMaxRadius"
                                (onValidation)="updateLocationCoords($event)">
            </app-address-picker>
            <ng-container
                *ngIf="authService.canManageLocationsOrPlants() && location.type === LocationType.CHEP">
                <ng-container *ngTemplateOutlet="locationConfigurationIndicators"></ng-container>
            </ng-container>
        </app-tab>

        <app-tab *ngIf="!onConfig && (authService.canViewTrailerReports() || authService.canManageLocations)"
                 [tabId]="'trailer'"
                 [selected]="activeTab === 'trailer'"
                 [tabTextKey]="'local-loads.locations.detail.tab.trailers'"
                 (selectedChange)="activeTab = 'trailer'">
            <ng-container *ngTemplateOutlet="locationTrailers"></ng-container>
        </app-tab>

        <app-tab *ngIf="onConfig" [tabId]="'overview'"
                 [selected]="activeTab === 'overview'"
                 [tabTextKey]="'local-loads.locations.detail.tab.overview'"
                 (selectedChange)="activeTab = 'overview'">
            <div class="locationDetail-config-container">
                <div class="locationDetail-config">
                    <ng-container *ngTemplateOutlet="locationInfo"></ng-container>
                    <app-address-picker class="locationDetail-config-addressPicker"
                                        [latitude]="location.latitude"
                                        [longitude]="location.longitude"
                                        [radius]="location.configuration.forcedCheckinMaxRadius"
                                        (onValidation)="updateLocationCoords($event)">
                    </app-address-picker>
                </div>
                <ng-container
                    *ngIf="authService.canManageLocationsOrPlants() && location.type === LocationType.CHEP">
                    <ng-container *ngTemplateOutlet="locationConfigurationIndicators"></ng-container>
                </ng-container>
                <div *ngIf="authService.canViewTrailerReports() || authService.canManageLocations" class="m-t-md">
                    <ng-container *ngTemplateOutlet="locationTrailers"></ng-container>
                </div>
            </div>
        </app-tab>

        <app-tab *ngIf="onConfig && authService.canManageLocationsOrPlants()"
                 [tabId]="'cma-cico-config'"
                 [selected]="activeTab === 'cma-cico-config'"
                 [tabTextKey]="'local-loads.locations.detail.tab.cma-cico-config'"
                 (selectedChange)="activeTab = 'cma-cico-config'">
            <form class="locationDetail-config-container" #locationDetailForm="ngForm">
                <!--  Location detail configuration -->
                <div class="form-group">
                    <label class="control-label" for="regions"
                           [i18n]="'local-loads.locations.detail.modals.configuration.region.label'"></label>
                    <ng-select class="regions-select form-control input-lg"
                               name="regions"
                               id="regions"
                               [items]="allRegions"
                               bindLabel="name"
                               [addTag]="false"
                               [i18n]="[{target: 'attribute:placeholder', key: 'local-loads.locations.detail.modals.configuration.region.placeholder'},
                            {target: 'attribute:notFoundText', key: 'local-loads.locations.detail.modals.configuration.region.not-found'}]"
                               [hideSelected]="true"
                               [multiple]="false"
                               [(ngModel)]="configurationForm.region"
                               [clearable]="false"
                               (change)="regionChange()">
                    </ng-select>
                </div>
                <hr class="hrConfig">

                <div class="localisation-config-wrapper">
                    <div class="form-group">
                        <label class="control-label" for="forcedCheckinMaxRadius"
                               [i18n]="'local-loads.locations.detail.modals.configuration.position-radius.title'"></label>

                        <div class="position-radius-wrapper">
                            <div class="position-wrapper">
                                <label class="m-b-sm"
                                       [i18n]="'local-loads.locations.detail.modals.configuration.position-radius.position-title'"></label>
                                <span
                                    [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.modals.configuration.position-radius.latitude', params: { lat: location.latitude }}]"></span>
                                <span
                                    [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.modals.configuration.position-radius.longitude', params: { lng: location.longitude }}]"></span>
                            </div>

                            <div class="radius-wrapper">
                                <label class="m-b-sm"
                                       [i18n]="'local-loads.locations.detail.modals.configuration.position-radius.radius-title'"></label>
                                <div class="radius-input" id="forcedCheckinMaxRadius">
                                    <ng-container
                                        *ngIf="configurationForm.region.distanceUnit === DistanceUnit.KILOMETERS; else milesPicker">
                                        <input type="range"
                                               min="100"
                                               max="500"
                                               step="10"
                                               [width]="500"
                                               name="forcedCheckinMaxRadiusRange"
                                               [(ngModel)]="forcedCheckinMaxRadiusInMeters"
                                               (ngModelChange)="forcedCheckinMaxRadiusInMiles = getConvertedMilesRadius($event)">
                                        <input type="number"
                                               name="forcedCheckinMaxRadius"
                                               class="form-control"
                                               min="100"
                                               max="500"
                                               [(ngModel)]="forcedCheckinMaxRadiusInMeters"
                                               (ngModelChange)="forcedCheckinMaxRadiusInMiles = getConvertedMilesRadius($event)"
                                               (keydown)="onNumberInputKeydown($event)">
                                        <span
                                            [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.modals.configuration.conversion.meters',  params: { conversion: forcedCheckinMaxRadiusInMiles}}]"></span>
                                    </ng-container>
                                    <ng-template #milesPicker>
                                        <input type="range"
                                               min="0.06"
                                               max="0.3"
                                               step="0.02"
                                               [width]="500"
                                               [(ngModel)]="forcedCheckinMaxRadiusInMiles"
                                               (ngModelChange)="forcedCheckinMaxRadiusInMeters = getConvertedMetersRadius($event)">
                                        <input type="number"
                                               name="forcedCheckinMaxRadius"
                                               class="form-control"
                                               min="0.06"
                                               max="0.31"
                                               [(ngModel)]="forcedCheckinMaxRadiusInMiles"
                                               (ngModelChange)="forcedCheckinMaxRadiusInMeters = getConvertedMetersRadius($event)"
                                               (keydown)="onNumberInputKeydown($event)">
                                        <span
                                            [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.modals.configuration.conversion.miles', params: { conversion: forcedCheckinMaxRadiusInMeters}}]"></span>
                                    </ng-template>
                                </div>
                                <small class="help-block m-b-sm"
                                       [i18n]="'local-loads.locations.detail.modals.configuration.position-radius.radius-sublabel'"></small>
                            </div>
                        </div>
                    </div>
                    <app-address-picker class="locationDetail-config-addressPicker"
                                        [latitude]="location.latitude"
                                        [longitude]="location.longitude"
                                        [radius]="forcedCheckinMaxRadiusInMeters"
                                        (onValidation)="updateLocationCoords($event)">
                    </app-address-picker>
                </div>
                <hr class="hrConfig">
                <div class="form-group" *ngIf="location.type !== LocationType.CUST">
                    <label class="control-label"
                           [i18n]="'local-loads.locations.detail.modals.configuration.check-in-out-options'"></label>
                    <div>
                        <label class="m-b-sm"
                               [i18n]="'local-loads.locations.detail.modals.configuration.force-checkin-title'"></label>
                        <div>
                            <app-switcher-form [(ngModel)]="configurationForm.enableForceCheckin" name="enableForceCheckin"
                                          [labelKey]="'local-loads.locations.detail.modals.configuration.force-checkin'">
                            </app-switcher-form>
                            <small class="help-block m-b-none"
                                   [i18n]="'local-loads.locations.detail.modals.configuration.force-checkin-sublabel'"></small>
                        </div>
                    </div>
                </div>
                <hr class="hrConfig" *ngIf="location.type === LocationType.CHEP && location.configuration?.colt">
                <div class="form-group" *ngIf="location.type === LocationType.CHEP && location.configuration?.colt">
                    <label class="control-label" [i18n]="'regions.form.sap-document-type-upload-to-by.title'"></label>
                    <div class="region-feature-item">
                        <div class="region-feature-name">
                            <span class="sap-flag" [i18n]="'regions.form.sap-document-type-upload-to-by.label'"></span>
                        </div>

                        <div class="region-feature-value-string">
                            <span>{{ configurationForm.region.features.sapDocumentTypeUploadToBlueyonder }}</span>
                        </div>
                    </div>
                </div>
                <hr class="hrConfig">
                <div class="form-group">
                    <label class="control-label" [i18n]="'eta-approximations.title'"></label>

                    <div class="radio">
                        <label for="region-values">
                            <input type="radio" [value]="EtaApproximationSource.REGION" id="region-values"
                                   [name]="'region-values'"
                                   [(ngModel)]="etaApproximationSource" (change)="etaApproximationSourceChange()">
                            <i class="fa radio-icon"></i>
                            <span
                                [i18n]="'local-loads.locations.detail.modals.configuration.eta-approximation.region'"></span>
                        </label>
                        <label for="personalized-values">
                            <input type="radio" [value]="EtaApproximationSource.PERSONALIZED" id="personalized-values"
                                   [name]="'region-values'" [(ngModel)]="etaApproximationSource"
                                   (change)="etaApproximationSourceChange()">
                            <i class="fa radio-icon"></i>
                            <span
                                [i18n]="'local-loads.locations.detail.modals.configuration.eta-approximation.overridden'"></span>
                        </label>
                    </div>
                    <app-eta-approximation-form
                        [writeMode]="etaApproximationSource === EtaApproximationSource.PERSONALIZED"
                        [bufferDurations]="configurationForm.bufferDurations"></app-eta-approximation-form>
                </div>
                <!--  End of location detail configuration-->

                <!-- CMA Configuration-->
                <div class="form-group">
                    <label class="control-label"
                           [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite-config.title'"></label>
                    <div class="form-group _bloc">
                        <div class="sap-container">
                            <label class="sap-title"
                                   [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.title'"></label>
                            <app-switcher-form [(ngModel)]="cmaLiteActivated" name="cma-lite"></app-switcher-form>
                        </div>

                        <div *ngIf="cmaLiteActivated">
                            <small class="help-block m-b-none"
                                   [translate]="'local-loads.locations.detail.modals.configuration.cma-lite.sublabel'"></small>

                            <div class="flex-row m-t-md">
                                <div class="radio">
                                    <label for="specific-carriers">
                                        <input type="radio" [value]="CmaLiteCarrierConfiguration.SPECIFIC_CARRIERS"
                                               id="specific-carriers" [name]="'cma-lite-carriers-configuration'"
                                               [(ngModel)]="cmaLiteCarriersConfiguration">
                                        <i class="fa radio-icon"></i>
                                        <span
                                            [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.carriers.specific'"></span>
                                    </label>
                                </div>
                                <div
                                    *ngIf="cmaLiteCarriersConfiguration === CmaLiteCarriersConfiguration.SPECIFIC_CARRIERS"
                                    class="options-all-carriers">
                                    <small
                                        [i18n]="[{target: 'innerHTML', key : 'local-loads.locations.detail.modals.configuration.cma-lite.carrier-count', params: {nbCarriers: cmaLiteCarrierLinkedNumber} }]"></small>
                                    <button class="btn btn-sm pull-right btn-primary"
                                            [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.carriers.edit-carriers'"
                                            (click)="launchEditCarrier()"></button>
                                </div>
                            </div>
                            <div
                                *ngIf="this.cmaLiteActivated && this.cmaLiteCarriersConfiguration === CmaLiteCarrierConfiguration.SPECIFIC_CARRIERS && this.cmaLiteCarrierLinkedNumber === 0">
                                <div class="m-l-lg m-b-sm m-t-sm">
                            <span style="color: red"
                                  [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.errors.specific-no-carriers'"></span>
                                </div>
                            </div>
                            <div class="flex-row">
                                <div class="radio">
                                    <label for="all-carriers">
                                        <input type="radio" [value]="CmaLiteCarrierConfiguration.ALL_CARRIERS"
                                               id="all-carriers"
                                               [name]="'cma-lite-carriers-configuration'"
                                               [(ngModel)]="cmaLiteCarriersConfiguration">
                                        <i class="fa radio-icon"></i>
                                        <span
                                            [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.carriers.all'"></span>
                                    </label>
                                </div>
                            </div>

                            <spacer size="16"></spacer>
                            <app-data-filter-fieldSet
                                [fieldsetTitleKey]="'local-loads.locations.detail.modals.configuration.cma-lite.deliveries.title'">
                                <div>
                                    <small class="help-block m-b-none"
                                           [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.deliveries.sublabel'"></small>

                                    <div class="flex-column">
                                        <div class="radio">
                                            <label for="z2-international">
                                                <input type="radio"
                                                       [value]="CmaLiteDeliveriesConfiguration.INTERNATIONAL_ISSUES"
                                                       id="z2-international"
                                                       [name]="'cma-lite-deliveries-configuration-values'"
                                                       [(ngModel)]="cmaLiteDeliveriesConfiguration">
                                                <i class="fa radio-icon"></i>
                                                <span
                                                    [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.deliveries.international'"></span>
                                            </label>
                                        </div>
                                        <div class="radio">
                                            <label for="z2-all" class="flex-auto">
                                                <div class="flex"></div>
                                                <input type="radio"
                                                       [value]="CmaLiteDeliveriesConfiguration.ALL_ISSUES"
                                                       id="z2-all"
                                                       [name]="'cma-lite-deliveries-configuration-values'"
                                                       [(ngModel)]="cmaLiteDeliveriesConfiguration">
                                                <i class="fa radio-icon"></i>
                                                <span
                                                    [i18n]="'local-loads.locations.detail.modals.configuration.cma-lite.deliveries.all'"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </app-data-filter-fieldSet>
                        </div>
                    </div>
                </div>
                <!-- End of CMA configuration-->

                <!-- CICO Configuration -->
                <ng-container *ngIf="location.configuration?.colt">
                    <div class="form-group">
                        <label class="control-label"
                               [i18n]="'local-loads.locations.detail.modals.configuration.cico-config-title'"></label>

                        <div class="form-group _bloc">
                            <!-- there is no region configuration for this flag -->
                            <app-modal-configuration
                                [locationFeature]="location.configuration.cicoMobileEnabled"
                                [regionFeature]="RegionFeatureStatus.AVAILABLE"
                                [titleLabelKey]="'local-loads.locations.detail.modals.configuration.cico-mobile-title'"
                                [secondPartTitleLabelKey]="'local-loads.locations.detail.modals.configuration.cico-mobile'"
                                [subTitleLabelKey]="'local-loads.locations.detail.modals.configuration.cico-mobile-sub-label'"
                                (valueChange)="configurationForm.cicoMobile = $event">
                            </app-modal-configuration>
                        </div>

                        <div class="form-group _bloc">
                            <app-modal-configuration
                                [locationFeature]="location.configuration.cmaCicoAlignment"
                                [regionFeature]="location.configuration.region.features.cmaCicoAlignment"
                                [titleLabelKey]="'local-loads.locations.detail.modals.configuration.cma_cico_alignment.title'"
                                [subTitleLabelKey]="'local-loads.locations.detail.modals.configuration.cma_cico_alignment.sublabel'"
                                (valueChange)="cmaCicoAlignment = $event">
                            </app-modal-configuration>
                        </div>

                        <div class="form-group _bloc">
                            <app-modal-configuration
                                [locationFeature]="location.configuration.askZ2EtaCico"
                                [regionFeature]="location.configuration.region.features.askZ2EtaCico"
                                [titleLabelKey]="'local-loads.locations.detail.modals.configuration.ask-cico-eta.title'"
                                [subTitleLabelKey]="'local-loads.locations.detail.modals.configuration.ask-cico-eta.sublabel'"
                                (valueChange)="askZ2EtaCico = $event">
                            </app-modal-configuration>
                        </div>

                        <div class="form-group _bloc">
                            <app-modal-configuration
                                [locationFeature]="location.configuration.z1CheckoutToMyChep"
                                [regionFeature]="location.configuration.region.features.z1CheckoutToMyChep"
                                [titleLabelKey]="'local-loads.locations.detail.modals.configuration.z1-checkout-to-my-chep.title'"
                                [subTitleLabelKey]="'local-loads.locations.detail.modals.configuration.z1-checkout-to-my-chep.sublabel'"
                                (valueChange)="z1CheckoutToMyChep = $event">
                            </app-modal-configuration>
                        </div>

                        <div class="form-group _bloc">
                            <app-modal-configuration
                                [locationFeature]="location.configuration.documentDownloadQrCodeFeature === OnOffFeature.ON"
                                [regionFeature]="location.configuration.region.features.documentDownloadQrCodeAvailability"
                                [titleLabelKey]="'local-loads.locations.detail.modals.configuration.document-download-qr-code-feature.title'"
                                [subTitleLabelKey]="'local-loads.locations.detail.modals.configuration.document-download-qr-code-feature.sublabel'"
                                (valueChange)="documentDownloadQrCode = ($event ? OnOffFeature.ON : OnOffFeature.OFF)">
                            </app-modal-configuration>
                        </div>
                    </div>


                    <div class="ibox" *ngIf="location.type === LocationType.CHEP">
                        <div class="ibox-title border-primary">
                <span class="ibox-title-text"
                      [i18n]="'local-loads.locations.detail.tablet-configuration.option.title'"></span>
                            <button class="btn btn-i btn-primary m-l-auto m-b-none"
                                    (click)="openOptionConfigurationCreation(optionConfigurationModal)"><i
                                class="fa fa-plus"></i>
                                <span
                                    [i18n]="'local-loads.locations.detail.tablet-configuration.option.button.creation'"></span>
                            </button>
                        </div>

                        <div class="ibox-content no-padding">
                            <div class="table-responsive">
                                <table class="trailers-table table table-striped">
                                    <thead>
                                    <tr class="trailers-table-header">
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.option.number'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.option.button-caption'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.option.print-mode-label'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.option.api-username'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.option.api-password'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.option.used-on-mobile'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.option.edit'"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let option of options; let index = index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ option.buttonCaption }}</td>
                                        <td>{{ option.printMode + (option.printMode === 'EMAIL' ? ' - ' + option.printerEmail : '') }}</td>
                                        <td>{{ option.apiUsername }}</td>
                                        <td>{{ option.apiPassword }}</td>
                                        <td>{{ option.usedOnMobile ? 'Yes' : 'No' }}</td>
                                        <td>
                                            <button class="btn btn-outline-secondary btn-sm pull-right"
                                                    (click)="openOptionConfigurationEdition(optionConfigurationModal, option)">
                                                <i
                                                    class="fa fa-edit"></i></button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="no-trailer" *ngIf="options.length === 0"
                                 [i18n]="'local-loads.locations.detail.tablet-configuration.option.empty'">
                            </div>
                        </div>
                    </div>

                    <div class="ibox" *ngIf="location.type === LocationType.CHEP">
                        <div class="ibox-title border-primary">
                <span class="ibox-title-text"
                      [i18n]="'local-loads.locations.detail.tablet-configuration.profile.title'"></span>
                            <button class="btn btn-i btn-primary m-l-auto m-b-none"
                                    (click)="openProfileConfigurationCreation(profileConfigurationModal)"><i
                                class="fa fa-plus"></i>
                                <span
                                    [i18n]="'local-loads.locations.detail.tablet-configuration.profile.button.creation'"></span>
                            </button>
                        </div>

                        <div class="ibox-content no-padding">
                            <div class="table-responsive">
                                <table class="trailers-table table table-striped">
                                    <thead>
                                    <tr class="trailers-table-header">
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.profile.name'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.profile.check-in'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.profile.check-out'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.profile.options'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.profile.support-number'"></th>
                                        <th [i18n]="'local-loads.locations.detail.tablet-configuration.profile.edit'"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let profile of profiles">
                                        <td>{{ profile.name }}</td>
                                        <td>{{ profile.checkinAllowed ? 'Yes' : 'No' }}</td>
                                        <td>{{ profile.checkoutAllowed ? 'Yes' : 'No' }}</td>
                                        <td>{{ displayIndexOptions(profile) }}</td>
                                        <td>{{ profile.supportPhoneNumber ? profile.supportPhoneNumber.e164Number : 'None' }}</td>
                                        <td>
                                            <button class="btn btn-outline-secondary btn-sm pull-right"
                                                    (click)="openProfileConfigurationEdition(profileConfigurationModal, profile)">
                                                <i
                                                    class="fa fa-edit"></i></button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="no-trailer" *ngIf="profiles.length === 0"
                                 [i18n]="'local-loads.locations.detail.tablet-configuration.profile.empty'">
                            </div>
                        </div>
                    </div>

                    <div class="ibox"
                         *ngIf="location.configuration.safetyIcons && location.configuration.safetyIcons.length > 0">
                        <div class="ibox-title border-primary">
                            <span class="ibox-title-text" [i18n]="'local-loads.locations.detail.tablet-configuration.safetyIcons.title'"></span>
                        </div>

                        <div class="ibox-content no-padding">
                            <div class="safety-icon-container">
                                <span *ngFor="let icon of location.configuration.safetyIcons">
                                    <img class="icon-img" [src]="'/assets/safety-icons/'+icon+'.png'" [alt]="icon">
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <!-- End of CICO configuration -->
            </form>
        </app-tab>

        <app-tab *ngIf="onConfig && location.type === LocationType.CHEP && location.configuration.colt"
                 [tabId]="'sap-flags'"
                 [selected]="activeTab === 'sap-flags'"
                 [tabTextKey]="'local-loads.locations.detail.tab.sap-flags'"
                 (selectedChange)="activeTab = 'sap-flags'">
            <div class="locationDetail-config-container">
                <ng-container *ngTemplateOutlet="sapFlags"></ng-container>
            </div>
        </app-tab>
    </app-tabs>

    <div class="overlay-footer-item locationDetail-footer">
        <button class="btn btn-i btn-primary"
                *ngIf="location && authService.canManageLocationsOrPlants() && (activeTab === 'info' || activeTab === 'trailer')"
                (click)="openConfiguration()">
            <i class="fa fa-cog"></i>
            <span [i18n]="'local-loads.locations.detail.information.buttons.configure'"></span>
        </button>
        <button class="btn btn-i btn-default"
                *ngIf="location && authService.canManageLocationsOrPlants() && activeTab === 'sap-flags'"
                (click)="exportSapConfig()">
            <i class="fa fa-download"></i>
            <span [i18n]="'local-loads.locations.detail.information.buttons.download-json'"></span>
        </button>
        <button class="btn btn-i btn-primary"
                *ngIf="location && authService.canManageLocationsOrPlants() && activeTab === 'cma-cico-config'"
                [disabled]="(locationDetailForm?.pristine)
                    || (cmaLiteActivated && cmaLiteCarriersConfiguration === CmaLiteCarriersConfiguration.SPECIFIC_CARRIERS && cmaLiteCarrierLinkedNumber === 0)
                    || (configurationForm.bufferDurations && (!configurationForm.bufferDurations.d1 || !configurationForm.bufferDurations.d2 || !configurationForm.bufferDurations.d3))
                    || (forcedCheckinMaxRadiusInMeters < FORCED_CHECKIN_MAX_RADIUS_MIN_VALUE)
                    || (forcedCheckinMaxRadiusInMeters > FORCED_CHECKIN_MAX_RADIUS_MAX_VALUE)"
                (click)="updateLocationConfiguration()">
            <i class="fa fa-save"></i>
            <span [i18n]="'local-loads.locations.detail.information.buttons.save'"></span>
        </button>
        <button class="btn btn-i btn-default"
                *ngIf="location && location.type === LocationType.CHEP && authService.canManageLocationsOrPlants() && (activeTab !== 'cma-cico-config' && activeTab !== 'sap-flags')"
                (click)="downloadForceCheckinPdf()">
            <i class="fa fa-qrcode"></i>
            <span [i18n]="'local-loads.locations.detail.information.qr-code.download'"></span>
        </button>
    </div>
</app-overlay-panel>

<app-location-carrier-configuration-edit
    *ngIf="locationCarrierConfigEditOpen"
    (closeRequested)="closeEditCarrier()"
    [locationContainerId]="location.id"></app-location-carrier-configuration-edit>

<ng-template #locationInfo>
    <div class="locationDetail-info">
        <div class="locationDetail-info-line">
            <i class="fa fa-hashtag locationDetail-info-line-icon"
               [i18n]="[{target: 'attribute:title', key: 'local-loads.locations.detail.information.glid'}]"></i>
            <div class="locationDetail-info-line-text">{{ location.glid }}</div>
        </div>

        <div *ngIf="googleTimezone || sapTimezone" class="locationDetail-info-line">
            <i class="fas fa-clock locationDetail-info-line-icon"></i>
            <div class="locationDetail-info-line-text-container">
                <div *ngIf="googleTimezone"
                     class="locationDetail-info-line-text"
                     [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.@timezone', params: {timezone: googleTimezone}}]"></div>
                <div *ngIf="sapTimezone"
                     class="locationDetail-info-line-text"
                     [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.@sapTimezone', params: {sapTimezone: sapTimezone}}]">
                </div>
            </div>
        </div>

        <div class="locationDetail-info-line _withCachInvalidate">
            <i class="fa fa-file locationDetail-info-line-icon"></i>
            <div class="locationDetail-info-line-text" *ngIf="location.vat">{{ location.vat }}</div>
            <div class="locationDetail-info-line-text" *ngIf="!location.vat"
                 [i18n]="'local-loads.locations.detail.information.unknown'"></div>
        </div>

        <div class="locationDetail-info-line _withCachInvalidate">
            <i class="fa fa-phone locationDetail-info-line-icon"></i>
            <div class="locationDetail-info-line-text" *ngIf="location.phoneNumber">{{ location.phoneNumber }}</div>
            <div class="locationDetail-info-line-text" *ngIf="!location.phoneNumber"
                 [i18n]="'local-loads.locations.detail.information.unknown'"></div>
            <button class="locationDetail-info-line-cache-invalidate" *ngIf="onConfig"
                    [i18n]="[{target: 'attribute:title', key: 'local-loads.locations.detail.information.invalidate-cache'}]"
                    (click)="invalidateCache()">
                <i class="fas fa-hourglass-end"></i>
            </button>
        </div>

        <div class="locationDetail-info-line">
            <i class="fa fa-map-marker-alt locationDetail-info-line-icon"></i>
            <div class="locationDetail-info-line-text-container">
                <div class="locationDetail-info-line-text">
                   <span *ngFor="let line of location.address.displayLines">{{ line }} </span>
                </div>
            </div>
        </div>

        <div class="locationDetail-info-line">
            <i class="far fa-dot-circle locationDetail-info-line-icon"></i>
            <div class="locationDetail-info-line-text">
                <span [i18n]="'local-loads.locations.detail.information.radius'"></span>:
                <span *ngIf="location.configuration.region?.distanceUnit == DistanceUnit.KILOMETERS">
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.conversion.meters', params: { value: location.configuration.forcedCheckinMaxRadius, conversion: (location.configuration.forcedCheckinMaxRadius / CONVERSION_CONSTANT).toFixed(2)}}]"></span>
                </span>
                <span *ngIf="location.configuration.region?.distanceUnit == DistanceUnit.MILES">
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.conversion.miles', params: { value: (location.configuration.forcedCheckinMaxRadius / CONVERSION_CONSTANT).toFixed(2), conversion: location.configuration.forcedCheckinMaxRadius}}]"></span>
                </span>
            </div>
        </div>

        <div class="locationDetail-info-line">
            <i class="fas fa-map-marker-alt locationDetail-info-line-icon"></i>
            <div class="locationDetail-info-line-text">
                <span>{{ location.latitude }} / {{ location.longitude }}</span>
                <i class="fa fa-check-circle" *ngIf="location.coordinatesValidated"></i>
                <div class="info-warning"
                     *ngIf="authService.canManageLocationsOrPlants() && !location.coordinatesValidated">
                    <i class="fa fa-exclamation-triangle m-r-xs"></i>
                    <span [i18n]="'local-loads.locations.detail.information.coords-not-approved'"></span>
                </div>
            </div>
            <button class="btn btn-i btn-warning m-l-auto m-b-none"
                    *ngIf="authService.canManageLocationsOrPlants() && !location.coordinatesValidated"
                    (click)="validateLocationCoords()">
                <i class="fa fa-check"></i>
                <span [i18n]="'local-loads.locations.detail.information.coords-approve'"></span>
            </button>
        </div>

        <div class="locationDetail-info-line">
            <i class="fa fa-globe locationDetail-info-line-icon"></i>
            <div class="locationDetail-info-line-text">
                <a class="cmaweb-link" *ngIf="canManageRegions"
                   [href]="link.goToRegion(location.configuration?.region?.name)"
                   target="_blank">{{ location.configuration?.region?.name }}</a>
                <span *ngIf="!canManageRegions">{{ location.configuration?.region?.name }}</span>
                <div class="info-warning"
                     *ngIf="authService.canManageLocationsOrPlants() && location.configuration.region?.id == 'DEFAULT_REGION'">
                    <i class="fa fa-exclamation-triangle m-r-xs"></i>
                    <span [i18n]="'local-loads.locations.detail.information.select-region'"></span>
                </div>
            </div>
            <button class="btn btn-i btn-warning m-l-auto m-b-none"
                    *ngIf="authService.canManageLocationsOrPlants() && location.configuration.region?.id == 'DEFAULT_REGION'"
                    (click)="openConfiguration()">
                <i class="fa fa-cog"></i>
                <span [i18n]="'local-loads.locations.detail.information.yms-compatibility-configure'"></span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #locationConfigurationIndicators>
    <div class="locationDetail-warning-message alert alert-info m-t-md"
         *ngIf="location.configuration.ymsCompatible === FeatureCompatibility.YES">
        <i class="fa fa-check-circle m-r-xs"></i>
        <span
            [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.is-yms-compatible'}]"></span>
    </div>
    <div class="locationDetail-warning-message alert alert-info m-t-md"
         *ngIf="location.configuration.ymsCompatible === FeatureCompatibility.NO">
        <i class="fa fa-minus-circle m-r-xs"></i>
        <span
            [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.is-not-yms-compatible'}]"></span>
    </div>
    <div class="locationDetail-warning-message alert alert-info m-t-md"
         *ngIf="location.configuration.additionnalHaulierAllowed">
        <span
            [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.additionnal-haulier-allowed'}]"></span>
    </div>
    <div class="locationDetail-warning-message alert alert-info m-t-md"
         *ngIf="!location.configuration.additionnalHaulierAllowed">
        <span
            [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.information.additionnal-haulier-not-allowed'}]"></span>
    </div>
</ng-template>

<ng-template #locationTrailers>
    <div class="ibox">
        <div class="ibox-title border-primary">
                <span class="ibox-title-text"
                      [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.trailers.title'}]"></span>
        </div>

        <div class="ibox-content no-padding">
            <div class="table-responsive">
                <table class="trailers-table table table-striped">
                    <thead>
                    <tr class="trailers-table-header">
                        <th [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.trailers.trailer-id'}]"></th>
                        <th [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.trailers.status'}]"></th>
                        <th [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.trailers.reported-at'}]"></th>
                        <th [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.trailers.reported-by'}]"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let trailer of trailers">
                        <td>{{ trailer.trailerId }}</td>
                        <td><span class="label large">{{ getTranslatedLabel(trailer.status) }}</span></td>
                        <td>{{ trailer.reportedAt | dateDiffFromNow | async }}</td>
                        <td>{{ trailer.reportedBy }}
                            <app-user-role-badge style="display: inline"
                                                 [role]="trailer.reportedByRole"></app-user-role-badge>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="no-trailer" *ngIf="trailers.length === 0"
                 [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.trailers.empty'}]">
            </div>
        </div>
    </div>
</ng-template>

<ng-template #sapFlags>
    <div class="form-group _bloc">
        <div class="sap-config-title">
            <label class="control-label" [i18n]="'local-loads.locations.detail.modals.configuration.SAP.title'"></label>
        </div>
        <app-sap-flags-list [containerConfiguration]="location.configuration"></app-sap-flags-list>
    </div>
</ng-template>

<ng-template #optionConfigurationModal let-c="close" let-d="dismiss">

    <div class="input-group-btn text-right" *ngIf="onConfig" [ngClass]="{'open' : isActionDropdownOpen}">
        <button class="btn btn-primary btn-lg dropdown-toggle" (click)="isActionDropdownOpen = !isActionDropdownOpen"
                type="button">
            Actions <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right">
            <li>
                <a class="dropdown-item" (click)="openOptionConfigurationDeletion(deleteOptionModal)">
                    <span
                        [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.form.actions.delete'}]"></span>
                </a>
            </li>
        </ul>
    </div>

    <form id="option-configuration-form" class="row">

        <div class="form-group">
            <label for="buttonCaption" class="control-label"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.button-caption'}]"></label>
            <input appAutofocus [(ngModel)]="optionForm.buttonCaption" class="form-control" id="buttonCaption"
                   name="buttonCaption"
                   #buttonCaptionInput="ngModel" aria-describedby="buttonCaptionHelp" required>
            <label class="error" *ngIf="buttonCaptionInput.dirty && buttonCaptionInput.errors?.required"
                   [i18n]="[{target: 'innerHTML', key: 'validation.required'}]">
            </label>
        </div>

        <div class="form-group">
            <label for="buttonCaption" class="control-label"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.printer-configuration'}]"></label>
            <div class="radio">
                <label *ngFor="let printMode of printModes">
                    <input type="radio" [value]="printMode" [name]="'name'" [(ngModel)]="optionForm.printMode">
                    <i class="fa radio-icon"></i>
                    <span
                        [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.print-mode.'+ printMode.toLowerCase()}]"></span>
                </label>
            </div>
        </div>

        <div class="form-group" *ngIf="optionForm.printMode === 'EMAIL'">
            <label for="printerEmail" class="control-label"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.printer-email'}]"></label>
            <input [(ngModel)]="optionForm.printerEmail" class="form-control" id="printerEmail" name="printerEmail"
                   #printerEmailInput="ngModel" aria-describedby="buttonCaptionHelp">
        </div>

        <div class="form-group">
            <label for="apiUsername" class="control-label"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.api-username'}]"></label>
            <input [(ngModel)]="optionForm.apiUsername" class="form-control" id="apiUsername" name="apiUsername"
                   #apiUsernameInput="ngModel" aria-describedby="apiUsernameHelp" required>
            <label class="error" *ngIf="apiUsernameInput.dirty && apiUsernameInput.errors?.required"
                   [i18n]="[{target: 'innerHTML', key: 'validation.required'}]">
            </label>
        </div>

        <div class="form-group">
            <label for="apiPassword" class="control-label"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.api-password'}]"></label>
            <input [(ngModel)]="optionForm.apiPassword" class="form-control" id="apiPassword" name="apiPassword"
                   #apiPasswordInput="ngModel" aria-describedby="apiPasswordHelp" required>
            <label class="error" *ngIf="apiPasswordInput.dirty && apiPasswordInput.errors?.required"
                   [i18n]="[{target: 'innerHTML', key: 'validation.required'}]">
            </label>
        </div>

        <div class="form-group">
            <app-switcher-form [(ngModel)]="optionForm.usedOnMobile" id="usedOnMobile" name="usedOnMobile"
                          [labelKey]="'local-loads.locations.detail.tablet-configuration.option.used-on-mobile'"></app-switcher-form>
        </div>

    </form>
</ng-template>

<ng-template #profileConfigurationModal let-c="close" let-d="dismiss">

    <div class="input-group-btn text-right" *ngIf="onConfig" [ngClass]="{'open' : isActionDropdownOpen}">
        <button class="btn btn-primary btn-lg dropdown-toggle" (click)="isActionDropdownOpen = !isActionDropdownOpen"
                type="button">
            Actions <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right">
            <li>
                <a class="dropdown-item" (click)="openProfileConfigurationDeletion(deleteProfileModal)">
                    <span
                        [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.profile.form.actions.delete'}]"></span>
                </a>
            </li>
        </ul>
    </div>

    <form id="profile-configuration-form" class="row">

        <div class="form-group">
            <label for="name" class="control-label"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.profile.name'}]"></label>
            <input appAutofocus [(ngModel)]="profileForm.name" class="form-control" id="name" name="name"
                   #nameInput="ngModel" aria-describedby="nameHelp" required>
            <label class="error" *ngIf="nameInput.dirty && nameInput.errors?.required"
                   [i18n]="[{target: 'innerHTML', key: 'validation.required'}]">
            </label>
        </div>

        <div class="form-group">
            <label class="control-label"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.profile.available-actions'}]"></label>
            <div class="checkbox">
                <label for="checkinAllowed">
                    <input [(ngModel)]="profileForm.checkinAllowed" class="form-control" id="checkinAllowed"
                           name="checkinAllowed" type="checkbox"
                           #checkinInput="ngModel" aria-describedby="apiPasswordHelp">
                    <i class="fa checkbox-icon"></i>
                    <span
                        [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.profile.check-in'}]"></span>
                </label>

                <label for="checkoutAllowed">
                    <input [(ngModel)]="profileForm.checkoutAllowed" class="form-control" id="checkoutAllowed"
                           name="checkoutAllowed" type="checkbox"
                           #checkoutInput="ngModel" aria-describedby="apiPasswordHelp">
                    <i class="fa checkbox-icon"></i>
                    <span
                        [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.profile.check-out'}]"></span>
                </label>
            </div>
        </div>

        <div class="form-group">
            <label class="control-label"
                   [i18n]="'local-loads.locations.detail.tablet-configuration.profile.support-phone-number'"></label><br>
            <ngx-intl-tel-input
                [cssClass]="'form-control' + phoneInput.valid ? '' : ' error'"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [selectFirstCountry]="true"
                [preferredCountries]="[preferredCountry]"
                [phoneValidation]="true"
                [inputId]="'support-number'"
                [numberFormat]="PhoneNumberFormat.International"
                [(ngModel)]="profileForm.supportPhoneNumber"
                name="phone" #phoneInput="ngModel">
            </ngx-intl-tel-input>
            <small class="error-block m-b-none " *ngIf="phoneInput.dirty && phoneInput.errors"
                   [i18n]="'local-loads.locations.detail.tablet-configuration.profile.phone-number-invalid'">
            </small>
        </div>

        <div class="form-group">
            <label class="control-label" for="options"
                   [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.profile.options'}]"></label>
            <ng-select class="regions-select form-control input-lg"
                       name="options"
                       id="options"
                       [items]="options"
                       [addTag]="false"
                       bindLabel="buttonCaption"
                       placeholder="No option(s) selected"
                       notFoundText="Option not found"
                       [hideSelected]="true"
                       [multiple]="true"
                       [(ngModel)]="profileForm.options"
                       #optionsInput="ngModel">
            </ng-select>
            <label class="error" *ngIf="optionsInput.dirty && optionsInput.errors?.required"
                   [i18n]="[{target: 'innerHTML', key: 'validation.required'}]">
            </label>
        </div>

    </form>
</ng-template>

<ng-template #deleteOptionModal let-c="close" let-d="dismiss">
    <span
        [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.option.form.modals.delete.content'}]"></span>
</ng-template>

<ng-template #deleteProfileModal let-c="close" let-d="dismiss">
    <span
        [i18n]="[{target: 'innerHTML', key: 'local-loads.locations.detail.tablet-configuration.profile.form.modals.delete.content'}]"></span>
</ng-template>
